'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducer;

var _reduxActions = require('redux-actions');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _IndexedAsyncData = require('conversations-internal-schema/indexed-async-data/IndexedAsyncData');

var _IndexedAsyncData2 = _interopRequireDefault(_IndexedAsyncData);

var _AsyncData = require('conversations-internal-schema/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _updateEntries = require('conversations-internal-schema/indexed-async-data/operators/updateEntries');

var _requestStarted = require('conversations-internal-schema/async-data/operators/requestStarted');

var _requestSucceededWithOperator = require('conversations-internal-schema/async-data/operators/requestSucceededWithOperator');

var _requestFailed = require('conversations-internal-schema/async-data/operators/requestFailed');

var _makeRequestActionTypes = require('conversations-internal-clients/action-creators/operators/makeRequestActionTypes');

var _resolvedAttachmentsActionTypes = require('../constants/resolvedAttachmentsActionTypes');

var _ActionTypes = require('../../thread-histories/constants/ActionTypes');

var _fileUploadsActionTypes = require('../../file-uploads/constants/fileUploadsActionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _makeRequestActionTyp = (0, _makeRequestActionTypes.makeRequestActionTypes)(_resolvedAttachmentsActionTypes.RESOLVE_ATTACHMENTS),
    RESOLVE_ATTACHMENTS_FAILED = _makeRequestActionTyp.FAILED,
    RESOLVE_ATTACHMENTS_STARTED = _makeRequestActionTyp.STARTED,
    RESOLVE_ATTACHMENTS_SUCCEEDED = _makeRequestActionTyp.SUCCEEDED;

var _makeRequestActionTyp2 = (0, _makeRequestActionTypes.makeRequestActionTypes)(_fileUploadsActionTypes.ASSOCIATE_ATTACHMENTS),
    ASSOCIATE_ATTACHMENTS_SUCCEEDED = _makeRequestActionTyp2.SUCCEEDED;

var _makeRequestActionTyp3 = (0, _makeRequestActionTypes.makeRequestActionTypes)(_ActionTypes.FETCH_THREAD_HISTORY),
    FETCH_THREAD_HISTORY_SUCCEEDED = _makeRequestActionTyp3.SUCCEEDED;

var initialState = (0, _IndexedAsyncData2.default)({
  notSetValue: (0, _AsyncData2.default)({ data: null })
});

var reducer = (_reducer = {}, _defineProperty(_reducer, RESOLVE_ATTACHMENTS_STARTED, function (state, action) {
  var fileIds = action.payload.requestArgs.fileIds;


  return (0, _updateEntries.updateEntries)(fileIds, function (fileId, asyncData) {
    return (0, _requestStarted.requestStarted)(asyncData);
  }, state);
}), _defineProperty(_reducer, RESOLVE_ATTACHMENTS_SUCCEEDED, function (state, action) {
  var _action$payload = action.payload,
      fileIds = _action$payload.requestArgs.fileIds,
      resolvedAttachments = _action$payload.data;


  return (0, _updateEntries.updateEntries)(fileIds, function (fileId, asyncData) {
    return (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
      var resolvedAttachment = (0, _get2.default)(fileId, resolvedAttachments);

      return resolvedAttachment;
    }, asyncData);
  }, state);
}), _defineProperty(_reducer, FETCH_THREAD_HISTORY_SUCCEEDED, function (state, action) {
  var resolvedAttachments = action.payload.data.files;


  var fileIds = resolvedAttachments.keySeq().toList();

  return (0, _updateEntries.updateEntries)(fileIds, function (fileId, asyncData) {
    return (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
      var resolvedAttachment = (0, _get2.default)(fileId, resolvedAttachments);

      return resolvedAttachment;
    }, asyncData);
  }, state);
}), _defineProperty(_reducer, ASSOCIATE_ATTACHMENTS_SUCCEEDED, function (state, action) {
  var resolvedAttachments = action.payload.data;


  var fileIds = resolvedAttachments.keySeq().toList();

  return (0, _updateEntries.updateEntries)(fileIds, function (fileId, asyncData) {
    return (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
      var resolvedAttachment = (0, _get2.default)(fileId, resolvedAttachments);

      return resolvedAttachment;
    }, asyncData);
  }, state);
}), _defineProperty(_reducer, RESOLVE_ATTACHMENTS_FAILED, function (state, action) {
  var fileIds = action.payload.requestArgs.fileIds;


  return (0, _updateEntries.updateEntries)(fileIds, function (fileId, asyncData) {
    return (0, _requestFailed.requestFailed)(asyncData);
  }, state);
}), _reducer);

exports.default = (0, _reduxActions.handleActions)(reducer, initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/resolved-attachments/reducers/resolvedAttachments.js
// module id = 900
// module chunks = 2 3